import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const SortBy = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState('');
  const dropdownRef = useRef(null);

  const sortOptions = [
    { id: 'relevance', label: 'Relevance' },
    { id: 'best-selling', label: 'Best Selling' },
    { id: 'top-rated', label: 'Top Rated' },
    { id: 'newest', label: 'Newest First' },
    { id: 'price-low-high', label: 'Price: Low to High' },
    { id: 'price-high-low', label: 'Price: High to Low' },
    { id: 'delivery-time', label: 'Fastest Delivery' },
    { id: 'trending', label: 'Trending' },
    { id: 'most-reviewed', label: 'Most Reviewed' }
  ];

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sortParam = urlParams.get('sort');
    if (sortParam && sortOptions.some(option => option.id === sortParam)) {
      setSelectedSort(sortParam);
    }
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectSort = (sortId) => {
    setSelectedSort(sortId);
    
    // Auto-apply when selection is made
    const url = new URL(window.location);
    url.searchParams.set('sort', sortId);
    window.history.pushState({}, '', url);
    
    setIsOpen(false);
  };

  const clearAll = () => {
    setSelectedSort('');

    const url = new URL(window.location);
    url.searchParams.delete('sort');
    window.history.pushState({}, '', url);
    
    setIsOpen(false);
  };

  const getSelectedLabel = () => {
    const selected = sortOptions.find(option => option.id === selectedSort);
    return selected ? selected.label : 'Sort by';
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block w-[100px] md:w-[140px]" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="flex items-center justify-between w-full px-2 md:px-4 py-1 md:py-2 text-[12px] md:text-sm font-medium text-gray-700 bg-white border border-[#185BC3] rounded-[50px] shadow-sm hover:bg-gray-50 focus:outline-none"
      >
        <span className='text-[#185BC3] truncate'>{getSelectedLabel()}</span>
        <ChevronDown className={`w-4 h-4 ml-1 transition-transform text-[#185BC3] font-extrabold duration-200 ${isOpen ? 'transform rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="p-1.5 md:p-3 absolute z-10 w-40 md:w-64 mt-2 md:origin-top-right bg-white border border-[#9D9D9D40] rounded-md shadow-[5px]">
          <div className="flex flex-col gap-2">
            <p className='text-black font-medium font-poppins text-[12px] md:text-[16px]'>Sort by</p>
            
            <div className="max-h-48 overflow-y-auto">
              {sortOptions.map((option) => (
                <button
                  key={option.id}
                  onClick={() => selectSort(option.id)}
                  className={`w-full text-left px-1.5md:px-3 py-2 text-[12px] md:text-sm rounded hover:bg-gray-50 transition-colors ${
                    selectedSort === option.id 
                      ? 'bg-[#185BC3] bg-opacity-10 text-[#185BC3] font-medium' 
                      : 'text-gray-700'
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
            
            {selectedSort && (
              <div className="flex justify-center mt-3 pt-2 border-t border-gray-200">
                <button 
                  onClick={clearAll}
                  className='border-[1px] border-[#174568] text-[#174568] md:text-[15px] text-[12px] rounded-[30px] py-[.5px] px-4 hover:bg-gray-50'
                >
                  Clear
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SortBy;
